import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) { setItems([]); setWishlist([]); return; }
    try {
      const [c, w] = await Promise.all([api.get("/cart"), api.get("/wishlist")]);
      setItems(c.data.items || []);
      setWishlist(w.data.items || []);
    } catch {}
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const addToCart = async (product_id, quantity = 1) => {
    if (!user) { toast.error("Please login to add to cart"); return false; }
    await api.post("/cart/add", { product_id, quantity });
    toast.success("Added to cart");
    refresh();
    return true;
  };
  const updateQty = async (product_id, quantity) => {
    await api.post("/cart/update", { product_id, quantity });
    refresh();
  };
  const toggleWishlist = async (product_id) => {
    if (!user) { toast.error("Please login to use wishlist"); return; }
    const r = await api.post("/wishlist/toggle", { product_id, quantity: 1 });
    toast.success(r.data.state === "added" ? "Added to wishlist" : "Removed from wishlist");
    refresh();
  };

  const cartCount = items.reduce((s, i) => s + i.quantity, 0);
  const wishlistIds = new Set(wishlist.map((p) => p.product_id));

  return (
    <CartContext.Provider value={{ items, wishlist, wishlistIds, cartCount, refresh, addToCart, updateQty, toggleWishlist }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
